import { render, staticRenderFns } from "./Noty.vue?vue&type=template&id=57b35d68&"
import script from "./Noty.vue?vue&type=script&lang=js&"
export * from "./Noty.vue?vue&type=script&lang=js&"
import style0 from "./Noty.vue?vue&type=style&index=0&id=57b35d68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports